<template>
  <div>
    <div class="col-md-12">
      <div class="ts-rounded">
        <div class="d-flex justify-content-between">
          <div class="text-primary ts-font-bold">
            {{
              $t(
                'school.academic.setup.program.subject.core_subjects.assessment_components'
              )
            }}
          </div>
          <div>
            <a href="#" v-tooltip="$t('scoreComponent.addMoreComponent')" @click.prevent="addNewComponent"
              class="btn btn-xs btn-primary">
              <i class="far fa-plus-square"></i>
            </a>
          </div>
        </div>
        <div class="ts-overflow-y-auto" style="max-height: 50vh;">
          <table style="width:100%" class="ui-table">
            <!-- <draggable tag="tbody" v-model="comDatatable"> -->
            <tr v-for="(item, index) in comDatatable" :key="index"
              class="ts-bg-gray-200 ts-rounded ts-border-white ts-border-8">
              <td style="padding: 8px 8px 5px 5px;" class="ts-rounded">
                <input v-model.trim="comDatatable[index].comp_item_name" type="text" class="form-components"
                  style="width:100%" />
                <component-items :index="index" v-model="item.component_items" />
                <ts-checkbox v-model="item.is_appear_in_score_entry">
                  {{ $t('school.academic.setup.program.subject.core_subjects.is_appear_in_score_entry') }}
                </ts-checkbox>
                <ts-checkbox v-model="item.is_auto_from_att">
                  {{ $t('school.academic.setup.program.subject.core_subjects.getAutoFromAttendance') }}
                </ts-checkbox>
              </td>
              <td style="width:10px;padding: 5px" valign="middle" class="ts-rounded">
                <a href="#" class="btn btn-xs btn-danger" @click.prevent="removeItem(index, comDatatable[index])">
                  <i class="fas fa-trash"></i>
                </a>
              </td>
            </tr>
            <!-- </draggable> -->
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import draggable from 'vuedraggable'
import ComponentItems from './component-items.vue'

export default {
  name: 'assessmentComponent',
  props: {
    value: {}
  },
  components: {
    ComponentItems
  },
  data() {
    return {
      comDatatable: []
    }
  },
  methods: {
    addNewComponent() {
      this.comDatatable.push({
        subject_comp_id: 0,
        comp_item_name: null,
        is_appear_in_score_entry: true,
        is_auto_from_att: false,
        display_order: this.comDatatable.length,
        component_items: []
      })
    },
    removeItem(index, item) {
      if (item.subject_comp_id === 0) {
        this.comDatatable[index].component_items = []
        this.comDatatable.splice(index, 1)
        return
      }

      this.$store
        .dispatch('subjectCore/removeComponent', item.subject_comp_id)
        .then(response => {
          if (response.message_id == 0) {
            this.$toasted.success(response.message)
            this.comDatatable[index].component_items = []
            this.comDatatable.splice(index, 1)
          } else {
            this.$toasted.error(response.message)
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    pushToComDatatable() {
      this.comDatatable = []
      this.value.forEach(data => {
        let detail = Object.assign({}, this.newItem, data, {
          subject_comp_id: data.subject_comp_id,
          comp_item_name: data.comp_item_name,
          is_appear_in_score_entry: data.is_appear_in_score_entry,
          is_auto_from_att: data.is_auto_from_att,
          display_order: data.display_order,
          component_items: data.component_items
        })

        this.$nextTick(() => {
          this.comDatatable.push(detail)
        })
      })
    }
  },
  watch: {
    value: {
      handler(val) {
        if (_.isEqual(val, this.comDatatable)) return

        this.pushToComDatatable()
      },
      deep: true,
      immediate: true
    },

    comDatatable: {
      handler(val) {
        if (_.isEqual(val, this.value)) return

        this.$emit('input', val)
      },
      deep: true
    }
  }
}
</script>
<style scoped>
.form-components {
  border: 1px solid #d3d8de;
  outline: none !important;
  padding: 5px 7px;
  border-radius: 5px;
}
</style>
